import { apiGet, apiPut } from "./http";
import type { MemberRow } from "./types";

export function fetchMember(tenantLegacyId: string, memberLegacyId: string) {
  return apiGet<MemberRow>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/members/${encodeURIComponent(memberLegacyId)}`,
  );
}

export type PatchMemberRequest = {
  levelName?: string;
  status?: string;
  levelChangeNote?: string;
  displayName?: string;
  realName?: string;
  email?: string;
  phone?: string;
  city?: string;
  idNumber?: string | null;
  avatarUrl?: string | null;
  wxOpenId?: string | null;
};

export function putMember(tenantLegacyId: string, memberLegacyId: string, body: PatchMemberRequest) {
  return apiPut<MemberRow>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/members/${encodeURIComponent(memberLegacyId)}`,
    body,
  );
}
